import { render } from "./Autocheck.vue?vue&type=template&id=9abc9f1c"
import script from "./Autocheck.vue?vue&type=script&lang=js"
export * from "./Autocheck.vue?vue&type=script&lang=js"

import "./Autocheck.vue?vue&type=style&index=0&id=9abc9f1c&lang=css"
script.render = render

export default script